var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 11.112 11.112",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.98 -25.343)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.95238 0 0 .95238 -2.3059 1.4714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-53.98 35.457v-9.1165c0-0.13232 0.02575-0.2595 0.07591-0.38156 0.05128-0.12206 0.12307-0.23078 0.21642-0.32412 0.09335-0.09334 0.20205-0.16514 0.32413-0.21642 0.12205-0.05026 0.24924-0.0759 0.38156-0.0759h9.1165c0.13232 0 0.25951 0.02566 0.38158 0.0759 0.12205 0.05128 0.23078 0.12308 0.3241 0.21642 0.09335 0.09334 0.16616 0.20206 0.21645 0.32412 0.05024 0.12206 0.07588 0.24924 0.07588 0.38156v9.1165c0 0.13232-0.02575 0.25951-0.07588 0.38156-0.05032 0.12206-0.1231 0.23078-0.21645 0.32412-0.09331 0.09334-0.20205 0.16616-0.3241 0.21643-0.12208 0.05024-0.24927 0.0759-0.38158 0.0759h-9.1165c-0.13232 0-0.25951-0.0256-0.38156-0.0759-0.12208-0.05024-0.23078-0.12309-0.32413-0.21643-0.09335-0.09334-0.16514-0.20206-0.21642-0.32412-0.05024-0.12205-0.07591-0.24924-0.07591-0.38156z",
    fill: "#1e4587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-48.015 29.588v0.60209h0.93749l-0.12412 0.94262h-0.81337v2.4207h-0.97547v-2.4207h-0.81234v-0.94262h0.81234v-0.69646c0-0.8062 0.49439-1.2483 1.2165-1.2483 0.24105 0 0.48517 0.01232 0.7293 0.03897v0.84211h-0.50158c-0.39285 0-0.46873 0.18873-0.46873 0.46157z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.2bb5f4061702cb20309d4e0bc3e0f595.svg";
export { ForwardRef as ReactComponent };